import React from 'react';
import { FieldArray, getIn } from 'formik';
import { SortableContainer, SortableElement, arrayMove } from 'react-sortable-hoc';

import styles from './reorderFormStyles';

const ReorderForm = ({ modalId, attr, renderItem }) => {
  const renderFieldArray = ({ form: { values, setFieldValue, isSubmitting } }) => {
    const items = getIn(values, attr);
    const onSortEnd = ({ oldIndex, newIndex }) => {
      const newItems = arrayMove(items, oldIndex, newIndex);
      setFieldValue(attr, newItems);
    };
    const SortableItem = SortableElement(({ value }) => renderItem(value));
    class ListComponent extends React.Component {
      render() {
        return (
          <ul className={styles.sortableList}>
            {this.props.items.map((value, idx) => (
              <SortableItem key={idx} index={idx} value={value} disabled={isSubmitting} />
            ))}
          </ul>
        );
      }
    }
    const SortableList = SortableContainer(ListComponent, { withRef: true });
    return (
      <div>
        <SortableList
          helperClass={styles.sortableHelper}
          items={items}
          onSortEnd={onSortEnd}
          getContainer={() => document.getElementById(modalId)}
          lockAxis="y"
        />
      </div>
    );
  };
  return <FieldArray name={attr} render={renderFieldArray} />;
};

export default ReorderForm;
